import { render, staticRenderFns } from "./_tags_manager.vue?vue&type=template&id=430a58ee&"
import script from "./_tags_manager.vue?vue&type=script&lang=js&"
export * from "./_tags_manager.vue?vue&type=script&lang=js&"
import style0 from "./_tags_manager.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports